export default __webpack_public_path__ + "static/media/logo.bf12fc31.png";